import React , {useEffect , useState } from "react";
import "./lebenslauf.css";
// Header
import { MainHeaderr } from "../../Components/mainHeader/HeaderMain";
// Components
import { ImageContainer } from "../../Components/cv/imageContainer";
import { CvHeader } from "../../Components/cv/CvHeader/CvHeader";

// Body Screens
import { Aboutme } from "../../Components/cv/CvScreens/Abouteme/Abouteme";
import { Ausbildungs } from "../../Components/cv/CvScreens/Ausbildungs/Ausbildungs";
import { Praktika } from "../../Components/cv/CvScreens/Praktika/Praktika";
import { Kenntnisse } from "../../Components/cv/CvScreens/Kenntnisse/Kenntnisse";

// Pass Data 
import { Headeritems } from "../../Components/cv/CvHeader/CvHeader";

import { fetchDataLeb } from "../../Components/Service/data";

import { DropFiles } from "../../Components/DropFiles/DropFiles";

import { AdminToolCv } from "../../Components/AdminTools/AdminTools";

import { dataAllCv } from "../../Components/AdminTools/AdminTools";

export var AusbildungsBody = 0;
export var allData = [];
export var allDataCv = "";


export const getDataCv = () => {
    return allData;
}


export const LebensLauf = () =>{


    /*_*/ const [ rendSec , setRendsec ] = useState("");




    window.addEventListener("DOMContentLoaded" , ()=>{
        setTimeout(() => {
            let bodyScr4een = document.querySelectorAll(".bodyScr4een");
            let cvBodyLayer = document.querySelectorAll(".cvBodyLayer");

            let H = bodyScr4een[0].children[0].getBoundingClientRect().height;
            document.getElementById("cvBodyLayer").style.height = H + "px";

            const cvBodyLayerWidth = document.getElementById("cvBodyLayer").getBoundingClientRect().width;
            const toTRANS = document.getElementById("toTRANS");

            const Headeritems = document.getElementsByClassName("HeaderItem");
            for (let i = 0; i < Headeritems.length; i++) {
                Headeritems[i].addEventListener("click" , ()=>{
                    const TransValue = cvBodyLayerWidth * i;
                    toTRANS.style.transform = "translateX(-"+TransValue+"px)";

                    // Body Height
                    let H = bodyScr4een[i].children[0].getBoundingClientRect().height;
                    document.getElementById("cvBodyLayer").style.height = H + "px";
                    
                    AusbildungsBody = cvBodyLayer;
                });
            }
        }, 200);
    });

    useEffect(()=>{
        getData();
        toAdminToolFunc();
    },[]);

    const toAdminToolFunc = () =>{
        const sawwllksssaqseerwww2 = document.getElementById("sawwllksssaqseerwww2");
        sawwllksssaqseerwww2.addEventListener("click" , ()=>{
            const removeSectionCV = document.getElementsByClassName("removeSectionCV");
            setTimeout(() => {
                for (let i = 0; i < removeSectionCV.length; i++) {
                    removeSectionCV[i].addEventListener("click" , ()=>{
                        setTimeout(() => {
                            renderSecses(dataAllCv.sec);
                        }, 250);
                    });
                }
            }, 250);


            setTimeout(() => {
                const moveIconsAtol = document.getElementsByClassName("moveIconsAtol");
                for (let i = 0; i < moveIconsAtol.length; i++) {
                    moveIconsAtol[i].addEventListener("click" , ()=>{
                        setTimeout(() => {
                            renderSecses(dataAllCv.sec);
                        }, 250);
                    });
                }
            }, 200);


            setTimeout(() => {
                const AddNewSecHandelBtn = document.getElementById("AddNewSecHandelBtn");
                AddNewSecHandelBtn.addEventListener("click" , () =>{
                    setTimeout(() => {
                        renderSecses(dataAllCv.sec);
                    }, 300);
                });
            }, 600);

        });
    }

    const getData = () =>{
        fetchDataLeb().then(data  =>{
            renderSecses(data.data.sec);
            allData = data.data;
        });
    }

    const renderSecses = (data) => {
        var rendr = [];
        ///////////////////////////////////////////////
        for (let i = 0; i < data.length; i++) {
            switch (data[i].Component) {
                case "ABM":
                    ABM(data[i].dat , data[i].head.title , i);
                    break;
                case "AUSB":
                    AUSB(data[i].dat , data[i].head.title , i);
                    break;
                case "PRCT":
                    PRCT(data[i].dat , data[i].head.title , i);
                    break;
                case "KENTS":
                    KENTS(data[i].dat , data[i].head.title , i);
                    break;
                default:
                    break;
            }
        }
        function ABM(prop , tit, i){
            rendr.push(<div className="bodyScr4een"> { <Aboutme data={prop} title={tit} index={i} />} </div>);
        }

        function AUSB(prop , tit, i){
            rendr.push(<div className="bodyScr4een"> { <Ausbildungs data={prop} title={tit} index={i} />} </div>);
        }

        function PRCT(prop , tit, i){
            rendr.push(<div className="bodyScr4een"> { <Praktika data={prop} title={tit} index={i} />} </div>);
        }

        function KENTS(prop , tit, i){
            rendr.push(<div className="bodyScr4een"> { <Kenntnisse data={prop} title={tit} index={i} />} </div>);
        }

        const rend = rendr.map( sec => sec );
        setRendsec(rend); 
        

    }






    /*
    const renderSecses = (data) => {
        const Components = {
            "ABM" :  <Aboutme data="data" /> ,
            "AUSB" : <Ausbildungs /> ,
            "PRCT" :  <Praktika /> ,
            "KENTS" : <Kenntnisse />
        };

        const rend = data.map( sec =>
            <div className="bodyScr4een">
                { Components[sec.Component] }
            </div> 
        );

        setRendsec(rend);
    }
    */
    







    const openDropFContainerAus = () =>{
        const BodyVisableZu = document.getElementById("BodyVisableZu");
        BodyVisableZu.classList.add("BodyVisableZu");

        const DropFileBG = document.getElementById("DropFileBG");
        setTimeout(() => {
            DropFileBG.classList.add("DropFileBGZu");
        }, 10);

        setTimeout(() => {
            const DropFileContainer = document.getElementById("DropFileContainer");
            DropFileContainer.classList.add("DropFileContainerZu");
        }, 400);
    }

    const uploadChangedDataToServer = () =>{
        
        setTimeout(() => { 
            /*
            let allKeys = Object.keys(ChangedData);

            for (let i = 0; i < allKeys.length; i++) {
                let ContenttoStr = JSON.stringify(ChangedData[allKeys[i]]);
                let FileNameToStr = allKeys[i];

                // API Request
                HomeDataRequest(FileNameToStr , ContenttoStr).then( respo => {
                    // Do somthing to know if data Changed
                });
            }
            */
            // Close SaveView
            let SaveChangContainer = document.getElementById("SaveChangContainer");
            SaveChangContainer.style.visibility = "hidden";
        }, 50);
        
    }
    const CloseSaveChange = () => {
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "hidden";
    }












    




    return(
        <div className="CvBody" >
            <MainHeaderr active={"NavListItemAtive"}  />
            <AdminToolCv />

            <div className="inbody d-flex justify-content-between">
                <ImageContainer />
                <div className="cvContainer">
                    <CvHeader />
                    <div className="cvBodyLayer" id="cvBodyLayer">

                        <div className="toTrans d-flex justify-content-start" id="toTRANS">

                            { rendSec }

                            {/* 
                            <div className="bodyScr4een" id="cvBodyLayer">
                                <Aboutme />
                            </div> 

                            <div className="bodyScr4een">
                                <Ausbildungs />
                            </div> 

                            <div className="bodyScr4een">
                                <Praktika />
                            </div> 

                            <div className="bodyScr4een">
                                <Kenntnisse />
                            </div> 

                            <div className="bodyScr4een">
                                <Kenntnisse />
                            </div>
                            */}

                        </div>

                    </div>


                </div>
            </div>

            <div className="SaveChangContainer" id="SaveChangContainer">
                <div className="BodySaveC d-flex justify-content-between align-items-center"> <div><p className="TitleSCSC">Do you want to save changes</p></div> <div className="savecloseBTNS d-flex justify-content-between align-items-center"> <div className="SaveBTN d-flex justify-content-center align-items-center" id="SaveBTN" onClick={uploadChangedDataToServer}>Save</div> <div className="CloseBTN d-flex justify-content-center align-items-center" id="CloseBTN" onClick={CloseSaveChange}>Close</div> </div> </div> 
            </div>

            <div className="asdasd DropFileContainerZu" id="DropFileContainer">
                <div className="DropFileBG DropFileBGZu" id="DropFileBG" onClick={openDropFContainerAus}></div>
                <div className="BodyVisableZu BodyVisable" id="BodyVisableZu"> <DropFiles /> </div>
            </div>
            
        </div>
    );
}